import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { compose } from "redux";

import { Redirect } from 'react-router-dom';


import { getFiles, createFolder, renameFile, deleteFile } from "../../store/actions/filesActions";



import TopBar from "../../components/TopBar";
import Sidebar from "../../components/Sidebar";

import { FileManager } from "@cubone/react-file-manager";
import "../../components/Files/files.css";

function Files(props) {

    const { token, getFilesFN, files, createFolderFN, renameFileFN, deleteFileFN } = props;
    ////////console.log("FILES PROPS: ", props);

    const API_URL = process.env.NODE_ENV === 'production'
        ? "https://api.demo1.raborisk.ai"
        : "https://api.demo1.raborisk.ai";

    useEffect(() => {
        getFilesFN();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const [currentPath, setCurrentPath] = useState("/");


    const onFileOpen = (file) => {

        //////////console.log(file);
        if (file.isDirectory) {
            return setCurrentPath(file.path);
        }

        window.open(file.s3_path, '_blank');
    }

    const onDownload = (files) => {
        ////////console.log(files);
        for (let file of files) {
            window.open(file.s3_path, '_blank');
        }
    }

    const onDelete = (files) => {
        for (let file of files) {
            deleteFileFN(file.id);
        }
    }

    // //////console.log("File Upload Headers Pages:", {
    //     Authorization: token,
    //     current_folder: currentPath || "/",
    //     department_id: "1",
    // });

    return token ? (

        <div className="flex flex-col w-full h-screen overflow-hidden">
            <TopBar className="fixed top-0 left-0 right-0 z-10" />
            <div className="flex flex-row w-full h-full">
                <Sidebar className="fixed top-0 left-0 h-screen pt-[64px] z-0" />
                <div id="dashboard-content" className="flex flex-col w-full p-4 overflow-auto"
                > {/* Adjust the margin-left to match Sidebar width */}

                    <FileManager onFileUploaded={getFilesFN} files={files} enableFilePreview={false} fileUploadConfig={{ url: API_URL + "/api/files/add_file", headers: { Authorization: token, "current_folder": currentPath || "/"} }} onCreateFolder={(folderName) => createFolderFN(folderName, currentPath)} onRefresh={getFilesFN} onFileOpen={onFileOpen} onDownload={onDownload} onRename={renameFileFN} onDelete={onDelete} />

                </div>
            </div>
        </div>
    ) : <Redirect to="/login" />;

}

const mapStateToProps = (state) => {
    ////console.log(state.files)
    return {

        token: state.auth.token,
        files: state.files?.files



    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getFilesFN: () => dispatch(getFiles()),
        createFolderFN: (folderName, currentFolder) => dispatch(createFolder(folderName, currentFolder)),
        renameFileFN: (file, newName) => dispatch(renameFile(file, newName)),
        deleteFileFN: (id) => dispatch(deleteFile(id))

    };
};


export default compose(connect(mapStateToProps, mapDispatchToProps))(Files);
